import {css} from "@emotion/css";

const ButtonDivisionSection = ({children, className}) => {
    return (
        <div
            className={`${
                css`
                  display: flex;
                  justify-content: end;
                  width: 100%;
                  align-items: baseline;
                `
            } ${className}`}>
            {children}
        </div>
    )
}
export default ButtonDivisionSection;